import { render, staticRenderFns } from "./NestedItem.vue?vue&type=template&id=95a2868e&scoped=true&"
import script from "./NestedItem.vue?vue&type=script&lang=js&"
export * from "./NestedItem.vue?vue&type=script&lang=js&"
import style0 from "./NestedItem.vue?vue&type=style&index=0&id=95a2868e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a2868e",
  null
  
)

export default component.exports